import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { map, take } from 'rxjs';
import { ProjectService } from '../services';

export const projectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService: AuthService = inject(AuthService);
  const projectService: ProjectService = inject(ProjectService);
  const router: Router = inject(Router);

  const projectId = route.params['projectId'];
  if (projectId) {
    return projectService.getProject(projectId).pipe(
      take(1),
      map((project) => {
        if (!project || project.deleted) {
          return router.parseUrl('error?code=404');
        } else {
          const { id, rules, groupIds } = authService.currentUser;
          const isProjectAdmin = rules.includes(UserRule.projectAdmin);
          if (
            isProjectAdmin ||
            project.createdBy === id ||
            project.assignees.includes(id) ||
            project.groupIds.some((gid) => groupIds.includes(gid))
          ) {
            return true;
          } else {
            return router.parseUrl('error?code=403');
          }
        }
      }),
    );
  }
  return router.parseUrl('error?code=404');
};
